<template>
    <component
      :is="`${stickerInstance.type}Sticker`"

      
      v-bind="{ ...sticker, ...sticker.data }"
      :isEditing="!previewEnabled && isSelected"
      :isPreventCover="!previewEnabled && isSelected"
      :isCover="!previewEnabled && isSelected"
      :setCover="setCover"
      :setCbClick="setCbClick"
      :files="files"
      :pageSelected="pageSelected"


      :stickerInstance="stickerInstance"
      :story="story"
      :isSelected="isSelected"
      @unselect="$emit('unselect')"
      @deleteSticker="deleteSticker"
    />
  </template>
  
  <script>

  import surveySticker from './survey.vue';
  import sliderSticker from './slider.vue';
  import mentionSticker from './mention.vue';
  import locationSticker from './location.vue';
  import hashtagSticker from './hashtag.vue';
  import linkSticker from './link.vue';
  import productSticker from './product.vue';
  import imageSticker from './image.vue';
  import gifSticker from './gif.vue';
  import musicSticker from './music.vue';
  import textSticker from './text.vue';
  import postSticker from './post.vue';
  import questionSticker from './question.vue';
  import countdownSticker from './countdown.vue';
  export default {
    components: {
        surveySticker,
        sliderSticker,
        mentionSticker,
        locationSticker,
        productSticker,
        imageSticker,
        gifSticker,
        hashtagSticker,
        linkSticker,
        musicSticker,
        textSticker,
        postSticker,
        questionSticker,
        countdownSticker
        
    },
    props: {
      sticker: {
        type: Object,
        required: true
      },
     
      isPreventCover: {
        type: Boolean,
        required: false
      },
      isCover: {
        type: Boolean,
        required: false
      },
      setCover: Function,
      setCbClick: Function,
      files:Object,
      pageSelected: Object,
      previewEnabled: Boolean,


      stickerInstance: {
        type: Object,
        required: true
      },
      story: Object,
      isSelected: Boolean
    },

    mounted () {
        if(this.sticker.isEditing && !this.isCover && !this.isPreventCover && !previewEnabled) {
            console.log('setCover mounted');
            this.setCover(true)
        }
    },
 
    methods: {
      deleteSticker(id) {
        this.$emit('deleteSticker', id);
      }
    },
  };
  </script>
  